module.exports = __webpack_public_path__ + "static/img/environment_04.96f9fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/environment_04.png
// module id = yrn1
// module chunks = 34